<app-dialog-heading [heading]="heading"></app-dialog-heading>
<div>
  <app-external-data-view [correlationId]="correlationId"
                          [showHeader]="false"></app-external-data-view>
</div>
